import { render } from "./ModerationStateBadge.vue.js?vue&type=template&id=59e77980!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ModerationStateBadge.vue?vue&type=template&id=59e77980"
import script from "./ModerationStateBadge.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ModerationStateBadge.vue?vue&type=script&lang=js"
export * from "./ModerationStateBadge.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ModerationStateBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/base-story-card/ModerationStateBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59e77980"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59e77980', __exports__)) {
    api.reload('59e77980', __exports__)
  }
  
  module.hot.accept("./ModerationStateBadge.vue.js?vue&type=template&id=59e77980!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ModerationStateBadge.vue?vue&type=template&id=59e77980", () => {
    api.rerender('59e77980', render)
  })

}


export default __exports__